import React from "react";

const CARDS = [0, 1, 2, 3];
const FIELDS = ["80%", "60%", "70%", "55%", "75%", "50%"];

const Bar = ({ width, height }) => <span className="crm-rollo__skel" style={{ width, height }} aria-hidden="true" />;

// Skeleton of the four cards (also shown while another terminal loads).
export function CardsSkeleton() {
  return (
    <div className="crm-ficha__grid" aria-hidden="true">
      {CARDS.map((card) => (
        <div key={card} className="crm-ficha__card crm-ficha__card--skel">
          <Bar width="35%" height="14px" />
          <div className="crm-ficha__dl">
            {FIELDS.map((width) => (
              <div key={width}>
                <Bar width="45%" height="10px" />
                <Bar width={width} height="14px" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

// Skeleton of the header, the terminal tabs and the cards (design Prompt 1: "Cargando").
export default function FichaSkeleton() {
  return (
    <>
      <div className="crm-ficha__skel-head" aria-hidden="true">
        <div className="crm-ficha__head-main">
          <Bar width="260px" height="24px" />
          <div className="crm-ficha__facts">
            {["54px", "42px", "48px", "42px", "42px"].map((width, index) => (
              <div key={`fact-${index}`}>
                <Bar width={width} height="10px" />
                <Bar width="80px" height="14px" />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="crm-ficha__tabs" aria-hidden="true">
        {[0, 1, 2].map((tab) => (
          <Bar key={tab} width="76px" height="14px" />
        ))}
      </div>
      <CardsSkeleton />
    </>
  );
}
